<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('common.setting')" center width="400px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">

        <div class="mydialog df-l-c-fs">
          <InputCustom :inputable="true" inputWidth="260" :inputValue="count" />
          <div class="box df-c-ct">
            <Keyboard :inputValue.sync="count" />
          </div>
        </div>
          
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogNum',
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Infinity
    },
  },
  data() {
    return {
      isShowDialog: false,
      count: '',
    }
  },
  watch: {
    count(n, o) {
      if (n === '') {
        return
      }
      if (Number(n) > this.max) {
        this.count = String(this.max)
      } else if (Number(n) < this.min) {
        this.count = String(this.min)
      }
    },
  },
  methods: {
    open(val = '') {
      this.count = String(val)
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.count = ''
    },
    submit() {
      this.$emit('update:count', this.count)
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px 40px 0;
  .box{margin-top: 20px;}
}
</style>